<template>
  <div class="details_form_item">
    <Form :model="dataModel" :label-width="100">
      <FormItem label="日志类型：">{{dataModel.logLevel}}</FormItem>
      <FormItem label="服务名：">{{dataModel.logType}}</FormItem>
      <FormItem label="日志内容：">{{dataModel.logContent}}</FormItem>
      <FormItem label="请求时间：">{{dataModel.createDate}}</FormItem>
    </Form>
    <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currentData"],
  components: {},
  data: function () {
    return {
      dataModel: {},
    };
  },

  created: function () {
    this.dataModel = this.currentData;
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
</style>